/* eslint-disable */
import React from "react";
import { useState } from "react";
import { Chart } from "react-google-charts";
import HeAppWrapper from "../../components/HeAppWrapper";
import "./App.scss";



import useScript from "../../hooks/useScript";
import { useEffect } from "react";

let data_url = "/wp-content/plugins/he-apps/legacyResources/appData/three-wests/";
let d3;

function App() {
    const [state, setState] = useState({
        data_econ: null,
        data_demo: null,
        allScriptsLoaded: false,
        visibleTable:'econ'
    });

    useEffect(() => {
        if (state.allScriptsLoaded) {
            d3 = window.d3;
            loadData();
        }
    }, [state.allScriptsLoaded]);

    const [loaded1, error1] = useScript("/wp-content/plugins/he-apps/legacyResources/jsLibs/d3/d3.min.js");
    if (!state.allScriptsLoaded && loaded1) {
        setState(prev => ({
            ...prev,
            allScriptsLoaded: true
        }));
    }

    const loadData = () => {
        let data_econ = [];
        data_econ.push([
            { type: "string", label: "County" },
            { type: "string", label: "County Seat" },
            { type: "string", label: "State" },
            { type: "string", label: "Three Wests Class" },
            { type: "number", label: "Income Volatility (1970-2013)" },
            { type: "number", label: "Average Earnings Per Job (2013)" },
            { type: "number", label: "Jobs in High Wage Services (2013)" }
        ]);
        let data_demo = [];
        data_demo.push([
            { type: "string", label: "County" },
            { type: "string", label: "County Seat" },
            { type: "string", label: "State" },
            { type: "string", label: "Three Wests Class" },
            { type: "number", label: "Population Change Per 1000 (2000-2013)" },
            { type: "number", label: "Change in Median Age (2000-2013)" },
            { type: "number", label: "Adults with a Bachelors Degree (2013)" }
        ]);

        d3.csv(data_url + "three-wests.csv", function(error, tableData) {
            tableData.forEach(row => {
                data_econ.push([
                    row.county, 
                    row.county_seat, 
                    row.state,
                    row.tw_class,
                    {v:row.income_volatility,f:decimalFormatter.format(row.income_volatility)},
                    {v:row.avg_earnings_per_job,f:currencyFormatter.format(row.avg_earnings_per_job)},
                    {v:row.pct_high_wage_svc_jobs,f:percentFormatter.format(row.pct_high_wage_svc_jobs)}
                ]);
                data_demo.push([
                    row.county, 
                    row.county_seat, 
                    row.state,
                    row.tw_class,
                    {v:row.pop_chg_per_1000,f:decimalFormatter.format(row.pop_chg_per_1000)},
                    {v:row.chg_in_median_age,f:decimalFormatter.format(row.chg_in_median_age)},
                    {v:row.pct_college_degree,f:percentFormatter.format(row.pct_college_degree)}
                ]);
            });
            setState(prev => ({ ...prev, data_econ: data_econ, data_demo:data_demo }));
        });
    };

    return (
        <HeAppWrapper className="app-three-wests">
            <div>Click the column headers in the sortable data tables below to change the sort order.</div>
            <div style={{ marginTop: 10, marginBottom: 10 }}>
                <button className="btn" style={{ marginRight: 10, opacity:state.visibleTable==='econ'?1:0.5 }} onClick={()=>{setState(prev => ({ ...prev, visibleTable: 'econ' }));}}>Economic Data</button>
                <button className="btn" style={{ opacity:state.visibleTable==='demo'?1:0.5 }} onClick={()=>{setState(prev => ({ ...prev, visibleTable: 'demo' }));}}>Demographic Data</button>
                {/* <input type="button" id="btnShowEcon" className="btn" style={{ marginRight: 10 }} value="Economic Data" onclick="drawTable('econ')" />
                <input type="button" style={{ marginRight: 10 }} id="btnShowDemo" className="btn" value="Demographic Data" onclick="drawTable('demo')" /> */}
            </div>
            <Chart
                chartType="Table"
                loader={<div>Loading Table</div>}
                data={state.visibleTable==='econ'?state.data_econ:state.data_demo}
                width={900}
                options={{
                    sortColumn: 4, 
                    sortAscending: false, 
                    showRowNumber:true,
                    cssClassNames: { headerCell: "he-google-sortable-table" }
                }}
            />
        </HeAppWrapper>
    );
}

export default App;

const percentFormatter = new Intl.NumberFormat("en-US", {
    style: "percent",
    maximumFractionDigits: 2
});
const decimalFormatter = new Intl.NumberFormat("en-US", {
    style: "decimal",
    maximumFractionDigits: 1
});

const currencyFormatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 0
});